// components/Contact.jsx
import React, { useState } from 'react';
import '../styles/Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    message: ''
  });

  const [formStatus, setFormStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the form data to your backend
    setFormStatus('success');
    setTimeout(() => {
      setFormStatus(null);
      setFormData({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
      });
    }, 3000);
  };

  const contactInfo = [
    {
      icon: '📞',
      title: 'Call Us 24/7',
      details: ['+1 (833) 493-6242'],
      action: 'tel:+18334936242'
    },
    {
      icon: '✉️',
      title: 'Email Us',
      details: ['info@plumberpro.com'],
      action: 'mailto:info@plumberpro.com'
    },
    {
      icon: '📍',
      title: 'Service Area',
      details: ['Serving all of USA', 'Licensed & Insured'],
      action: null
    },
    {
      icon: '🕐',
      title: 'Hours of Operation',
      details: ['24/7 Emergency Service', 'Same-Day Appointments'],
      action: null
    }
  ];

  const services = [
    'Emergency Plumbing',
    'Bathroom & Kitchen',
    'Drain Cleaning',
    'Water Heater Repair',
    'Pipe Repair & Install',
    'Toilet Repair',
    'Sewer Line Services',
    'Other'
  ];

  return (
    <section id="contact" className="contact">
      {/* Animated Background */}
      <div className="contact-bg">
        <div className="contact-bg-circle contact-bg-circle-1"></div>
        <div className="contact-bg-circle contact-bg-circle-2"></div>
        <div className="contact-bg-circle contact-bg-circle-3"></div>
      </div>

      <div className="contact-container">
        {/* Section Header */}
        <div className="contact-header">
          <span className="contact-subtitle">Get In Touch</span>
          <h2 className="contact-title">
            Contact <span className="contact-title-highlight">PlumberPro</span>
          </h2>
          <p className="contact-description">
            Have a plumbing emergency or need a free estimate? Reach out to us 
            and we'll get back to you as soon as possible.
          </p>
        </div>

        <div className="contact-grid">
          {/* Contact Info Cards */}
          <div className="contact-info">
            {contactInfo.map((info, index) => (
              <div 
                key={index} 
                className="contact-info-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="contact-info-icon">{info.icon}</div>
                <div className="contact-info-content">
                  <h3 className="contact-info-title">{info.title}</h3>
                  {info.details.map((detail, i) => (
                    <p key={i} className="contact-info-detail">{detail}</p>
                  ))}
                  {info.action && (
                    <a href={info.action} className="contact-info-link">
                      {info.title === 'Call Us 24/7' ? 'Call Now →' : 'Email Now →'}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Contact Form */}
          <div className="contact-form-wrapper">
            <div className="contact-form-container">
              <h3 className="contact-form-title">📋 Request a Free Quote</h3>
              <p className="contact-form-subtitle">
                Fill out the form and we'll get back to you within 30 minutes.
              </p>

              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="contact-form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name *"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="contact-form-input"
                  />
                </div>

                <div className="contact-form-row">
                  <div className="contact-form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address *"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="contact-form-input"
                    />
                  </div>
                  <div className="contact-form-group">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number *"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="contact-form-input"
                    />
                  </div>
                </div>

                <div className="contact-form-group">
                  <select
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="contact-form-select"
                    required
                  >
                    <option value="">Select a Service *</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div className="contact-form-group">
                  <textarea
                    name="message"
                    placeholder="Tell us about your plumbing issue..."
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    className="contact-form-textarea"
                  ></textarea>
                </div>

                <button type="submit" className="contact-form-btn">
                  <span className="contact-form-btn-shine"></span>
                  <span className="contact-form-btn-content">
                    📋 Send Message
                  </span>
                </button>

                {formStatus === 'success' && (
                  <div className="contact-form-success">
                    ✅ Message sent successfully! We'll contact you soon.
                  </div>
                )}
              </form>

              <div className="contact-form-trust">
                <span>🔒 Your information is safe with us</span>
                <span>⚡ Response within 30 minutes</span>
              </div>
            </div>
          </div>
        </div>

        {/* Emergency Banner */}
        <div className="contact-emergency">
          <div className="contact-emergency-content">
            <span className="contact-emergency-icon">🚨</span>
            <div className="contact-emergency-text">
              <h3 className="contact-emergency-title">Plumbing Emergency?</h3>
              <p className="contact-emergency-description">
                We're available 24/7 for all emergency plumbing services.
              </p>
            </div>
            <a href="tel:+18334936242" className="contact-emergency-btn">
              📞 Call Now: +1 (833) 493-6242
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;